import { DropdownButtonSectionProps } from "@/components/common/dropdown/data/dropdown-button-data";
import sectionStyles from "@/components/common/dropdown/styles/dropdown-section.module.scss";
import Image from "next/image";
import useHover from "@/hooks/use-hover";

const DropdownButtonSection = ({
  className,
  icon,
  hoverIcon,
  iconHeight,
  iconWidth,
  onClick,
  text,
}: DropdownButtonSectionProps) => {
  const { isHovering, onMouseEnter, onMouseLeave } = useHover();
  return (
    <div
      className={`${sectionStyles.dropdown_section_wrapper} ${className}`}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      {icon && (
        <Image
          alt={"icon"}
          src={isHovering ? hoverIcon ?? icon : icon}
          height={iconHeight ?? 18}
          width={iconWidth ?? 18}
        />
      )}
      {text && <div>{text}</div>}
    </div>
  );
};

export default DropdownButtonSection;
